import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var EpsSvg = function EpsSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF9A00",
    d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#300",
    d: "M8.91 14.5v-.791l-2.726-.004v-1.552h2.358v-.773h-2.35V9.861h2.662l.003-.783H5.272V14.5zm2.036 0v-1.965h1.118c1.155 0 1.924-.63 1.924-1.706 0-1.136-.874-1.751-2.044-1.751H10.02V14.5zm1.095-2.696H10.94V9.798h1.076c.634 0 1.106.356 1.106.979 0 .61-.446 1.027-1.08 1.027m4.815 2.771c1.298 0 2.119-.663 2.119-1.515 0-.574-.187-1.361-1.399-1.609l-.975-.217c-.637-.146-.828-.349-.828-.701 0-.488.472-.78 1.068-.78.6 0 1.08.225 1.148.87h.922c-.011-.878-.727-1.613-2.081-1.613-1.159 0-2.025.642-2.017 1.624.01.791.506 1.264 1.316 1.429l.997.217c.555.12.926.341.926.788 0 .502-.528.776-1.2.776-.633 0-1.136-.296-1.256-.844h-.945c.124 1.047 1.152 1.575 2.205 1.575"
  }));
};
export var Eps = function Eps(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: EpsSvg
  }));
};